import { useRuntimeConfig } from '#imports'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { storeToRefs } from 'pinia'
import z from 'zod'

import { useCareLogger } from '../../composables/logger/useCareLogger'

const allowedUsersSchema = z.union([
  z.literal('all'),
  z.number(),
  z.string().refine((val) =>
    val
      .trim()
      .split(',')
      .every((id) => !Number.isNaN(Number(id))),
  ),
])

export const useAuthorizeIntercomUsers = () => {
  const { logIntercomError } = useCareLogger()
  const { FF_ENABLED_INTERCOM_BY_USERS } = useRuntimeConfig().public

  const userStore = useUserStore()
  const { user } = storeToRefs(userStore)

  function checkAuthorizedIntercomUsers() {
    const parsedUsers = allowedUsersSchema.safeParse(
      FF_ENABLED_INTERCOM_BY_USERS,
    )

    if (!parsedUsers.success) {
      logIntercomError({
        errorTitle:
          '[INTERCOM] error with feature flag FF_ENABLED_INTERCOM_BY_USERS',
        errorDetail: {
          context:
            'The value of the FF_ENABLED_INTERCOM_BY_USERS must be a list of client id(s) or set to all',
          feature_flag_value: FF_ENABLED_INTERCOM_BY_USERS,
        },
      })

      return false
    }

    if (FF_ENABLED_INTERCOM_BY_USERS === 'all') {
      return true
    }

    if (
      typeof FF_ENABLED_INTERCOM_BY_USERS === 'number' &&
      user.value.clientId === FF_ENABLED_INTERCOM_BY_USERS
    ) {
      return true
    }

    if (
      typeof FF_ENABLED_INTERCOM_BY_USERS === 'string' &&
      FF_ENABLED_INTERCOM_BY_USERS.split(',')
        .map((id) => id.trim())
        .includes(user.value?.clientId?.toString() ?? '')
    ) {
      return true
    }

    return false
  }

  return {
    checkAuthorizedIntercomUsers,
  }
}
